import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { SettingService } from 'src/app/system-common/services/setting.service';
import * as Chart from 'chart.js';
import { DashboardService } from '../../services/dashboard.service';

@Component({
  selector: '',
  template: '',
})
export class ProductWiseChartHandler {
  chart: Chart;
  @Output() closeChart = new EventEmitter<string>();
  pieColorArray = [];
  @Input() usedFor;
  frequencyArr = [
    this.settingService.getLabelValue('monthly'),
    this.settingService.getLabelValue('quarterly'),
    this.settingService.getLabelValue('yearly'),
  ];
  frequency = this.settingService.getLabelValue('yearly');
  selectedCalculationYears: any = [];
  selectedFrequencyTemp: string = '';
  public calculationyears;
  private originalRectangleDraw;
  private userLoginData;

  //Product Chart
  lineChartPlugins;
  lineChartData;
  lineChartOptions;

  public agentProductWiseGraph: any;
  public selectedProduct: any;
  public selectedProductChannel: string = '';
  selectedChannelTemp: string;
  public agentProductWiseFullData;
  public agentProductWiseFilterBarChartData = [];
  filteredProductData = [];
  productsData;
  channelRotationInterval: any;
  channelRotationIndex = 0;
  productRawData;
  public productChart: boolean;
  isFilteredPRoductClicked: boolean;
  public agentProductChannels = [];
  public agentProductLabels = [];
  constructor(public service: DashboardService, public settingService: SettingService) {
    this.productChart = true;
    const dateStr = this.service.getDateFormatted(this.settingService.getSessionStorageValue('BatchDate'));
    const year = parseInt(dateStr.split('/')[2], 10);
    this.calculationyears = [String(year), String(year + 1)];
    this.originalRectangleDraw = Chart.elements.Rectangle.prototype.draw;

    if (sessionStorage.getItem('userLoginData') != undefined) {
      this.userLoginData = JSON.parse(sessionStorage.getItem('userLoginData'));
    }
  }

  ngOnInit() {
    this.loadBarChartDetails();
  }

  public loadBarChartDetails() {
    this.pieColorArray = this.service.getColor();
    setTimeout(() => {
      this.productWiseBarChartBrowser();
    }, 10);
  }

  /* Product Chart Code Starts Here */

  productWiseBarChartBrowser(frequency?, selectedProductChannels?, selectedProducts?, calculationYears?) {
    this.productChart = true;
    this.frequency = frequency || this.frequency || 'QUARTERLY';
    let apiObservable;
    if (this.usedFor === 'newBusiness' || this.usedFor === 'brokerNewBusiness') {
      apiObservable = this.service.getNewBusinessData(
        ['channelcd', 'productcd'],
        this.frequency,
        calculationYears
      );
    } else if (this.usedFor === 'performance' || this.usedFor === 'brokerPerformance') {
      apiObservable = this.service.getPerformanceData(
        ['channelcd', 'productcd'],
        this.frequency,
        calculationYears
      );
    } else {
      console.error('Invalid chart type provided.');
      return;
    }
    apiObservable.subscribe(
      (res) => {
        const rawData = this.service.extractApiData(res);
        if (!rawData) return;

        this.productRawData = rawData;
        const channelList = Object.keys(rawData);
        this.agentProductChannels = ['All', ...channelList];
        const allProductsSet = new Set<string>();
        if (this.usedFor === 'performance') {
          selectedProductChannels = channelList[0];
        }
        channelList.forEach((channel) => {
          const productList = Object.keys(rawData[channel]);
          productList.forEach((product) => allProductsSet.add(product));
        });

        this.agentProductLabels = ['All', ...Array.from(allProductsSet)];

        if (
          !selectedProductChannels ||
          (Array.isArray(selectedProductChannels) && selectedProductChannels.length === 0)
        ) {
          selectedProductChannels = ['All'];
        }

        if (!Array.isArray(selectedProductChannels)) {
          selectedProductChannels = [selectedProductChannels];
        }

        const selectedChannels =
          selectedProductChannels.includes('All') || !selectedProductChannels.length
            ? channelList
            : selectedProductChannels.filter((ch) => channelList.includes(ch));

        const chartColors = this.service.productColors();

        const masterXLabels: string[] = [];
        const xMeta: any[] = [];
        const labelMap = new Map<string, number>();
        let labelIndex = 0;
        const productSet = new Set<string>();
        selectedChannels.forEach((channel) => {
          let productList = Object.keys(rawData[channel]);

          // Apply product filter if selectedProducts is provided and not empty
          if (selectedProducts && selectedProducts.length > 0 && !selectedProducts.includes('All')) {
            productList = productList.filter((product) => selectedProducts.includes(product));
          }

          productList.forEach((product) => {
            productSet.add(product);
            const productData = rawData[channel][product];

            Object.keys(productData)
              .sort()
              .forEach((year) => {
                const yearObj = productData[year];
                if (!yearObj?.data) return;

                Object.keys(yearObj.data)
                  .sort()
                  .forEach((period) => {
                    const labelKey = `${channel} ${year} ${period}`;
                    if (!labelMap.has(labelKey)) {
                      labelMap.set(labelKey, labelIndex++);
                      masterXLabels.push(labelKey);
                      xMeta.push({ channel, year, period });
                    }
                  });
              });
          });
        });

        const datasets = [];

        Array.from(productSet).forEach((product) => {
          const dataPoints = Array(masterXLabels.length).fill(null);

          selectedChannels.forEach((channel) => {
            const productData = rawData[channel][product];

            if (productData) {
              Object.keys(productData).forEach((year) => {
                const yearObj = productData[year];
                if (!yearObj?.data) return;

                Object.entries(yearObj.data).forEach(([period, value]) => {
                  const labelKey = `${channel} ${year} ${period}`;
                  const idx = labelMap.get(labelKey);
                  if (idx !== undefined) {
                    dataPoints[idx] = value ?? 0;
                  }
                });
              });
            }
          });

          datasets.push({
            label: product,
            data: dataPoints,
            borderColor: chartColors[datasets.length % chartColors.length],
            backgroundColor: chartColors[datasets.length % chartColors.length],
            fill: false,
            tension: 0.3,
            pointStyle: 'circle',
            pointRadius: 6,
            pointHoverRadius: 10,
          });
        });

        type StructureMap = {
          [channel: string]: {
            from: number;
            to: number;
            years: {
              [year: string]: {
                from: number;
                to: number;
              };
            };
            products: {
              [product: string]: {
                from: number;
                to: number;
              };
            };
          };
        };

        const structureMap: StructureMap = {};
        const isTrue = this.usedFor !== 'performance';
        this.lineChartPlugins = {
          beforeDraw(chart) {
            const ctx = chart.ctx;
            const xAxis = chart.scales['x-axis-0'];
            const chartArea = chart.chartArea;
            const xMeta = chart.config.options.xMeta || [];

            if (!xMeta || xMeta.length === 0) return;

            ctx.save();
            ctx.font = '12px montserratregular, Arial, Helvetica, sans-serif';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'top';
            ctx.fillStyle = '#000000';
            ctx.strokeStyle = '#aaa';
            ctx.lineWidth = 1;
            const structureMap: StructureMap = chart.config.options.structureMap;
            if (!structureMap) return;

            xMeta.forEach((entry, idx) => {
              const { channel, year, product } = entry;

              // Channel initialization
              if (!structureMap[channel]) {
                structureMap[channel] = { from: idx, to: idx, years: {}, products: {} };
              } else {
                structureMap[channel].to = idx;
              }

              // Year initialization under channel
              if (!structureMap[channel].years[year]) {
                structureMap[channel].years[year] = { from: idx, to: idx };
              } else {
                structureMap[channel].years[year].to = idx;
              }

              // Product initialization under channel
              if (!structureMap[channel].products[product]) {
                structureMap[channel].products[product] = { from: idx, to: idx };
              } else {
                structureMap[channel].products[product].to = idx;
              }
            });

            // Drawing Labels
            Object.entries(structureMap).forEach(([channel, chData]) => {
              const startX = xAxis.getPixelForTick(chData.from);
              const endX = xAxis.getPixelForTick(chData.to);

              // Draw channel label
              if (isTrue) ctx.fillText(channel, (startX + endX) / 2, chartArea.top - 40);

              // Draw dashed line to separate channels
              ctx.beginPath();
              ctx.setLineDash([8, 5]);
              ctx.moveTo(endX + (xAxis.getPixelForTick(1) - xAxis.getPixelForTick(0)) / 2, chartArea.top);
              ctx.lineTo(endX + (xAxis.getPixelForTick(1) - xAxis.getPixelForTick(0)) / 2, chartArea.bottom);
              ctx.stroke();

              // Draw year labels under each channel
              Object.entries(chData.years).forEach(([year, yrData]) => {
                const yearStartX = xAxis.getPixelForTick(yrData.from);
                const yearEndX = xAxis.getPixelForTick(yrData.to);

                ctx.fillText(year, (yearStartX + yearEndX) / 2, chartArea.top - 20);
              });
            });

            ctx.restore();
          },
        };

        this.lineChartData = {
          labels: masterXLabels,
          datasets,
        };

        this.lineChartOptions = this.getLinceChartOptions(xMeta, structureMap);
      },
      (error) => {
        console.log('Error:', error);
        this.service.handleError(error);
      }
    );
  }

  public getLinceChartOptions(xMeta, structureMap) {
    const commonFontSettings = {
      fontFamily: 'montserratregular, Arial, Helvetica, sans-serif',
      fontColor: '#000000',
    };

    return {
      responsive: true,
      maintainAspectRatio: false,
      xMeta,
      structureMap,
      layout: { padding: { top: 40, bottom: 10, left: 10, right: 20 } },
      hover: { mode: 'nearest', intersect: true },
      scales: {
        xAxes: [
          {
            ticks: {
              display: this.frequency !== 'YEARLY',
              autoSkip: false,
              callback: function (value) {
                const parts = value.split(' ');
                const period = parts[parts.length - 1];
                return period;
              },
              ...commonFontSettings,
            },
          },
        ],
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              callback: (val) => val.toLocaleString(),
              ...commonFontSettings,
            },
          },
        ],
      },
      legend: {
        display: true,
        position: 'bottom',
        align: 'center',
        labels: {
          boxWidth: 12,
          fontSize: this.settingService.isMobileViewRendered() ? 8 : 12,
          padding: 15,
          ...commonFontSettings,
        },
      },
      tooltips: {
        mode: 'nearest',
        intersect: true,
        bodyFontFamily: commonFontSettings.fontFamily,
        callbacks: {
          title: (tooltipItems) => {
            const idx = tooltipItems[0].index;
            const meta = xMeta[idx];
            return `${meta.channel} — ${meta.period}, ${meta.year}`;
          },
          label: function (tooltipItem, data) {
            const datasetIndex = tooltipItem.datasetIndex;
            const index = tooltipItem.index;
            const dataset = data.datasets[datasetIndex];
            const currentValue = dataset.data[index];
            const totalAtPoint = data.datasets.reduce((sum, ds) => sum + (ds.data[index] || 0), 0);
            const percentage = totalAtPoint ? ((currentValue / totalAtPoint) * 100).toFixed(2) : '0';
            return `${dataset.label}: ${currentValue.toLocaleString()} (${percentage}%)`;
          },
        },
      },
      plugins: {
        datalabels: false,
      },
    };
  }

  /* Filter Code For Product Starts Here */
  onFilterProductData() {
    $('#agentProductWiseStatusModal').toggle();
  }

  closeProductModal() {
    $('#agentProductWiseStatusModal').hide();
    this.isFilteredPRoductClicked = false;
  }

  updateProductListForSelectedChannel() {
    if (!this.productRawData || !this.selectedChannelTemp) {
      this.agentProductLabels = [];
      return;
    }

    const channelData = this.productRawData[this.selectedChannelTemp];
    if (!channelData) {
      this.agentProductLabels = [];
      return;
    }

    const products = Object.keys(channelData);
    this.agentProductLabels = ['All', ...products];
  }

  filterProduct() {
    $('#agentProductWiseStatusModal').hide();
    this.selectedProductChannel = this.selectedChannelTemp;
    this.frequency = this.selectedFrequencyTemp;
    const selectedProducts = this.selectedProduct;
    this.productChart = false;
    setTimeout(() => {
      if (this.agentProductWiseGraph) {
        this.agentProductWiseGraph.destroy();
        this.agentProductWiseGraph = null;
      }
      this.productChart = true;
      setTimeout(() => {
        this.productWiseBarChartBrowser(
          this.frequency,
          this.selectedProductChannel,
          selectedProducts,
          this.selectedCalculationYears
        );
      }, 10);
    }, 10);
  }

  onDateRangeProductChange(event) {
    this.service.onDateRangeChange(event);
    this.productWiseBarChartBrowser(
      this.frequency,
      this.selectedChannelTemp,
      this.selectedProduct,
      this.selectedCalculationYears
    );
  }

  // Close the Chart on click of the close button
  onCloseClick() {
    this.closeChart.emit(this.chart);
  }

  clearData() {
    this.selectedChannelTemp = '';
    this.selectedProduct = [];
    this.selectedFrequencyTemp = '';
    this.selectedCalculationYears = [];

    this.frequency = this.settingService.getLabelValue('yearly');

    const datePicker: any = document.getElementById('mydaterange-picker12');
    if (datePicker) {
      datePicker.value = '';
    }

    $('#agentProductWiseStatusModal').hide();

    setTimeout(() => {
      if (this.agentProductWiseGraph) {
        this.agentProductWiseGraph.destroy();
        this.agentProductWiseGraph = null;
      }

      setTimeout(() => {
        this.productWiseBarChartBrowser(
          this.frequency,
          this.selectedChannelTemp,
          this.selectedProduct,
          this.selectedCalculationYears
        );
      }, 10);
    }, 10);
  }

  ngOnDestroy() {
    this.service.clear();
    Chart.elements.Rectangle.prototype.draw = this.originalRectangleDraw;
  }
}
